import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Table,
  Menu,
  Dropdown,
  message,
  Input,
  Spin,
} from "antd";
import "./EquipmentCostsC.less";
import { miscCostColumns, miscHeader } from "./config";
import { SearchOutlined } from "@ant-design/icons";
import api from "../../utils/api";
import { MoreActionIcon } from "../../utils/icons";
import AddAdminRates from "../../components/pop-ups/default-modal/AddAdminRates";
import DefaultBulkEntry from "../../components/pop-ups/default-modal/MaterialDefaultBulkEntry";
import { CSVLink } from "react-csv";

type miscType = {
  _id: string;
  item: string;
  cost: string;
};

const MiscCostC = () => {
  const [miscCost, setMiscCost] = useState<miscType[]>([]);
  const [showSingleItemModal, setShowSingleItemModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [miscSearched, setMiscSearched] = useState("");
  const [loading, setLoading] = useState<boolean>(true);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [item, setItem] = useState<any>({});
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    api
      .get("rates/cost/miscellaneous")
      .then((resp: any) => {
        setLoading(false);
        setMiscCost(resp);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleDelete = (id: string) => {
    api.delete(`rates/miscellaneous/${id}`).then(() => {
      setMiscCost(miscCost.filter((item: any) => item._id !== id));
    });
  };

  const found = miscCost?.filter((item: any) => {
    if (!miscSearched) {
      return true;
    }
    return item.item.toLowerCase().includes(miscSearched.toLowerCase());
  });

  const sortedData = found.slice().sort((a: any, b: any) => {
    const nameA = a.item.toLowerCase();
    const nameB = b.item.toLowerCase();
    return nameA.localeCompare(nameB);
  });

  const handleAdd = (values: any) => {
    if (edit) {
      api.put(`rates/miscellaneous/${item._id}`, values).then((resp: any) => {
        setMiscCost(
          miscCost.map((data: any) =>
            data._id === item._id ? { ...values, _id: item._id } : data
          )
        );
      });
    } else {
      api
        .post("rates", {
          category: "miscellaneous",
          rate: values,
        })
        .then((resp: any) => {
          setMiscCost([...miscCost, resp]);
        });
    }
    toggleSingleItemModal();
  };

  const handleAddCsv = (info: any) => {
    setButtonDisable(true);
    if (info.file.status === "done") {
      setButtonDisable(false);
      message.success("Successfully Uploaded");
      const resp = info.file.response.data;
      setMiscCost(resp);
      toggleBulkModal();
    } else if (info.file.status === "error") {
      setButtonDisable(false);
      message.error("Uploading Failed!");
    }
  };

  const toggleBulkModal = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };

  const toggleSingleItemModal = () => {
    !showSingleItemModal
      ? setShowSingleItemModal(true)
      : setShowSingleItemModal(false);
  };

  const handleSingleItem = () => {
    setEdit(false);
    setItem({});
    toggleSingleItemModal();
  };

  const handleEdit = (data: any) => {
    setItem(data);
    setEdit(true);
    toggleSingleItemModal();
  };

  const tableColumns = [
    ...miscCostColumns,
    {
      title: "Action",
      width: 100,
      render: (data: any) => {
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="edit"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleEdit(data)}
                >
                  Edit
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleDelete(data._id)}
                >
                  Delete
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <div style={{ cursor: "pointer" }}>
              <MoreActionIcon />
            </div>
          </Dropdown>
        );
      },
    },
  ];
  const handleBulkBtn = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };
  return (
    <div className="admin-ec-root">
      <DefaultBulkEntry
        buttonDisable={buttonDisable}
        showBulkModal={showBulkModal}
        toggleBulkModal={toggleBulkModal}
        url="rates/upload"
        handleAddCsv={handleAddCsv}
      />
      <AddAdminRates
        toggleSingleItemModal={toggleSingleItemModal}
        handleAdd={handleAdd}
        showSingleItemModal={showSingleItemModal}
        item={item}
        edit={edit}
      />
      <Row className="admin-ec-header" justify="space-between">
        <Col>
          <h1>Miscellaneous Labor Rates</h1>
        </Col>
        <Row gutter={12}>
          <Col>
            <Input
              className="search-manufacture-input"
              prefix={
                <SearchOutlined className="contractor-data-search-icon" />
              }
              placeholder="Search Misc"
              onChange={(e) => {
                setMiscSearched(e.target.value);
              }}
            />
          </Col>
          <div className="contractor-data-vertical-line " />
          <Col>
            <Button
              className="admin-ec-add-single-btn"
              onClick={handleSingleItem}
            >
              Add Single item
            </Button>
          </Col>
          <Col>
            <Button
              className="admin-ec-add-btn"
              type="primary"
              onClick={handleBulkBtn}
            >
              Bulk Entry
            </Button>
          </Col>
        </Row>
      </Row>
      {loading ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <>
          <hr style={{ border: "1px solid #E8E8E8", marginBottom: 30 }} />
          <Button
            className="default-bulk-btn"
            style={{ margin: "0px 20px 10px" }}
            type="primary"
          >
            <CSVLink
              data={miscCost}
              filename={"misc-rates"}
              headers={miscHeader}
              enclosingCharacter={""}
            >
              Download CSV
            </CSVLink>
          </Button>
          {miscCost.length > 0 && (
            <Table
              scroll={{ x: "900px" }}
              rowKey="_id"
              columns={tableColumns}
              dataSource={sortedData}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MiscCostC;
